import "./styles.scss";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { SelectButton } from "primereact/selectbutton";
import { DataTable } from "primereact/datatable";
import { useState, useEffect } from "react";
import { logout } from "../../services/Auth";
import { useAuth } from "../../context/AuthContext";
import { usePrivate } from "../../context/PrivateInfoContext";
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import { formatCurrency } from "../../utils/FormatCurrency";
import { Api } from "../../services/Api";
//import { pdfService } from "../../services/PdfService";
import BoletosDialog from "../../components/BoletosDialog";
import DownloadBoletoDialog from "../../components/DownloadBoletoDialog";
import SimpleLoading from "../../components/SimpleLoading";
import { toast } from "react-toastify";
import CreditCardDialog from "../../components/CreditCardDialog";
import InfoProtestoDialog from "../../components/InfoProtestoDialog";
import { InfoBody } from "../../components/ColumnBody";
import ConfirmaBoletoDialog from "../../components/ConfirmaBoletoDialog";
import whatsappPic from "../../assets/whatsapp.png";
import BandeiraCartaoDialog from "../../components/BandeiraCartao";
import {FaRegCreditCard} from "react-icons/fa";
import DialogConfirmacaoDias from "../../components/DialogConfirmacaoDias";
import { addDays, format } from "date-fns";

function Dashboard() {
  const navigate = useNavigate();
  const { user, provider } = useAuth();
  const {
    infoCobrancas,
    tableCobrancas,
    dynamicColumns,
    valorOriginal,
    valorBoleto,
    parcelasOpcoes,
    tableNegociacao,
    taxaBoleto,
    cartaoBandeira,
    first,
    setFirst,
    setPage,
    setReload,
    loading,
    setLoading,
  } = usePrivate();
  const [tipoPagamento, setTipoPagamento] = useState("Boleto");
  const [quantidadeParcelas, setQuantidadeParcelas] = useState();
  const [valorCartao, setValorCartao] = useState();
  const [dropdownValue, setDropdownValue] = useState([]);
  const [boletoData, setBoletoData] = useState([]);
  const [infoTaxa, setInfoTaxa] = useState([]);
  const [showNegociadas, setShowNegociadas] = useState(false);
  const [showDownloadBoletoDialog, setShowDownloadBoletoDialog] =
    useState(false);
  const [showInfoProtesto, setShowInfoProtesto] = useState(false);
  const [showCreditCardDialog, setShowCreditCardDialog] = useState(false);
  const [showBandeiraDialog,setShowBandeiraDialog] = useState(false);
  const [showConfirmacao, setShowConfirmacao] = useState(false);
  const [mostraConfirmacaoDias,setMostraConfirmacaoDias] = useState(false);
  const [cronograma,setCronograma] = useState([])
  // const [loading,setLoading] = useState(false);
  const optionsPagamento = ["Boleto"];

  useEffect(() => {
    getInfos();
  }, []);

  function sair() {
    logout();
    navigate("/");
  }

  const handleInfoTaxaClick = (e) => {
    setInfoTaxa(e);
    setShowInfoProtesto(true);
  };

  async function pagamento() {
    setShowConfirmacao(true);
  }

  async function pagamentoBoleto() {
    setLoading(true);
    try {
      const paymentData = createPaymentData();
      const { data } = await Api.post(
        "/paguecartorio/negotiation/create",
        paymentData
      );
      setBoletoData(data);
      setLoading(false);
      setReload((prevState) => !prevState);
      setShowDownloadBoletoDialog(true);
    } catch (error) {
      setLoading(false);
      toast.error("Erro ao gerar boleto, tente novamente mais tarde");
      console.log(error);
    }
  }

  // const getSegundaViaBoleto = async () => {
  //   const segundaViaInfos = { cobranca_id: 1, boleto_id: 2 };

  //   setLoading(true);
  //   try {
  //     const segundaVia = await Api.post(
  //       "api.paguedireto.com.br/boletos/recria",
  //       segundaViaInfos
  //     );
  //     setSegundaViaGerada(segundaVia);
  //     setLoading(false);
  //   } catch (e) {
  //     console.error(e);
  //     setLoading(false);
  //   }
  // };

  const getInfos = async (usuario_id, provider_id) => {
    // eslint-disable-next-line no-unused-vars
    const { data } = await Api.get(
      `genericnegotiation/list/${usuario_id}/${provider_id}`
    );
  };

  const cartaoParcelas = (e) =>{
    setReload(prevReload => !prevReload)
    setQuantidadeParcelas();
    setDropdownValue();
    setValorCartao();
    setShowBandeiraDialog(false)
  }

  async function pagamentoCredito(token) {
    setLoading(true);
    try {
      const paymentData = createPaymentData();
      paymentData.token_card = token;
      paymentData.tipo = "cartao";
      paymentData.cartao_bandeira = cartaoBandeira;
      paymentData.parcelas = quantidadeParcelas;
      console.log(paymentData)
      await Api.post("/paguecartorio/negotiation/create", paymentData);
      setLoading(false);
      setReload((prevState) => !prevState);
      setQuantidadeParcelas(0);
      setShowCreditCardDialog(false);
      //setShowCartaoConfirmaDialog(true)
      //console.log(data)
    } catch (error) {
      setLoading(false);
      if (error.response === undefined)
        return toast.error(
          "Erro ao gerar pagamento com cartão, tente novamente mais tarde"
        );
      if (error.response.status === 500)
        return toast.error("Erro de conexão com o servidor!");
      if (error.response.data.category === "card_declined")
        return toast.error("Cartão recusado, por favor verifique o seu cartão");
      return toast.error(
        "Erro ao gerar pagamento com cartão, tente novamente mais tarde"
      );
    }
  }

  function createPaymentData() {
    const PAYMENT_METHOD_QUANTITY = 1;
    const {
      cobrancas: [{ cobranca_id }],
    } = infoCobrancas;

    return {
      cobranca_id,
      parcelas: 1,
      tipo: "boleto",
      cobranca_qtd_meio_pagamento: PAYMENT_METHOD_QUANTITY,
      valor: valorOriginal,
      token_card: "",
      fee_direto: 0,
    };
  }

  const segundoBoleto = () => {
    return (
      <div className="segundaVia text-slate-700 text-center font-semibold mt-5">
        <h5>Segunda via do seu boleto</h5>
        <Button label="Segunda via" onClick={() => setLoading(true)} />
      </div>
    );
  };

  function continuarNegociacao() {
    const cronograma_array = criarCronograma();
    setCronograma(cronograma_array);
    setMostraConfirmacaoDias(true)
  }

  function criarCronograma(){
    const calendarioPagamento =
        [{
            parcela:1,
            valor: formatCurrency(valorBoleto),
            dia_pagamento: format(addDays(new Date(),3),'dd/MM/yyyy')
        }]
    return calendarioPagamento
  }


  return (
    <div
      className="gap-[4vh] lg:gap-[6vh] bg-gradient-to-b from-black to-stone-600
     pb-[14vh] pt-[4vh] px-[7vw] md:px-[4vh] lg:flex flex flex-col lg:flex-row 
    h-full w-screen lg:h-screen font-branding"
    >¨
      <div className="flex w-full lg:w-3/5 "> 
        <div className="fixed hover:scale-110 transition top-0 left-0 mt-[6vh] lg:mt-[1vh]
        ml-[1vw] z-50">
          {showNegociadas && (
            <BoletosDialog close={() => setShowNegociadas(false)} />
            )}
          {showDownloadBoletoDialog && (
            <DownloadBoletoDialog
              close={() => setShowDownloadBoletoDialog(false)}
              data={boletoData}
            />
          )}
          {showCreditCardDialog && (
            <CreditCardDialog
              close={() => setShowCreditCardDialog(false)}
              negotiate={(e) => pagamentoCredito(e)}
            />
          )}
          {showBandeiraDialog && (
            <BandeiraCartaoDialog
              close={() => {setShowBandeiraDialog(false);setTipoPagamento('Boleto')}}
              selecionarBandeira={(e) => cartaoParcelas(e)}
            />
          )}
          {showInfoProtesto && (
            <InfoProtestoDialog
              close={() => setShowInfoProtesto(false)}
              taxaSelecionada={infoTaxa}
            />
          )}
          {showConfirmacao && (
            <ConfirmaBoletoDialog
              close={() => setShowConfirmacao(false)}
              createBoleto={() => {
                tipoPagamento === "Boleto"
                  ? continuarNegociacao()
                  : setShowCreditCardDialog(true);
              }}
            />
          )}
          {mostraConfirmacaoDias && 
              <DialogConfirmacaoDias
              close={()=>setMostraConfirmacaoDias(false)} 
              aceite={()=>pagamentoBoleto()}   
              cronograma={cronograma}
              valor_pagamento={valorBoleto}
              />
          }

          <SimpleLoading status={loading} />
          <Button
            icon="pi pi-arrow-left"
            className="p-button-rounded"
            onClick={() => sair()}
            tooltip="Sair"
          ></Button>
        </div>
        <div className="w-full text-sky-900 h-full flex-row justify-end">
          <div
            className="card flex items-center lg:p-[4vh] p-[4vw] w-full mb-[4vh] 
              lg:h-1/4 font-semibold from-sky-100 to-sky-50 bg-gradient-to-tl"
          >
            <h4>
              Olá, {user}, aqui abaixo estão suas taxas e emolumentos na
              plataforma.
            </h4>
          </div>
          <div
            className="card p-[4vw] lg:p-[4vh] w-full h-3/4 
              from-sky-100 to-sky-50 bg-gradient-to-br"
          >
            <div className="h-full grid w-full">
              <div className=" font-semibold break-normal">
                <h4 className="mb-[2vh] font-branding-bold">
                  Tabelionato: {provider}
                </h4>
                <div className="boletosDialog overflow-auto w-full ">
                  {tableCobrancas.length > 0 ? (
                    <DataTable
                      value={tableCobrancas}
                      responsiveLayout="scroll"
                      scrollDirection="horizontal"
                      scrollHeight="35vh"
                      paginator
                      first={first}
                      onPage={(e) => {
                        setPage(e.page);
                        setFirst(e.first);
                        setReload((prevState) => !prevState);
                      }}
                      totalRecords={infoCobrancas.count}
                      rows={10}
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} de {last} do total de {totalRecords}"
                      lazy
                    >
                      {dynamicColumns.map((column, index) => (
                        <Column
                          key={index}
                          header={column.header}
                          field={column.field}
                          // headerStyle={column.header}
                          body={column.body}
                          style={column.style}
                        />
                      ))}
                      <Column
                        field="info"
                        header="Detalhes"
                        style={{ textAlign: "center" }}
                        body={(rowData) => (
                          <InfoBody
                            rowData={rowData}
                            handleClick={() => handleInfoTaxaClick(rowData)}
                          />
                        )}
                      />
                    </DataTable>
                  ) : (
                    <h4>
                      Você não possui nenhuma taxa pendente com este cartório
                    </h4>
                  )}
                </div>
              </div>
              <div className="font-semibold grid items-end">
                <div className="negotiationButton mt-[2vh]">
                  {tableNegociacao.length > 0 ? (
                    <Button
                      style = {{fontFamily:'Branding-Regular, serif'}}
                      label="Ver taxas e emolumentos já negociados"
                      onClick={() => setShowNegociadas(true)}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full lg:w-2/5 flex-row h-full">
        <div
          className="card p-[2vh] w-full mb-[4vh] lg:h-2/6 grid md:flex items-stretch
            gap-[2vh] from-sky-100 to-sky-50 bg-gradient-to-br"
        >
          <div
            className="BankServices w-full md:w-2/4 flex justify-center items-center h-full 
                rounded-xl"
          >
            <div className="text-slate-700 text-center font-semibold">
              <h6>Serviços Bancários</h6>
{tableCobrancas.length > 0  ? <h6 className="font-branding-bold">
                {tipoPagamento === "Boleto"
                  ? formatCurrency(taxaBoleto)
                  : formatCurrency(
                      valorCartao * quantidadeParcelas - valorOriginal
                    )}
              </h6> : <h6>-</h6>}
              <h4>Valor a Pagar</h4>
{tableCobrancas.length > 0  ? <h4 className="font-branding-bold">
                {tipoPagamento === "Boleto"
                  ? formatCurrency(valorBoleto)
                  : formatCurrency(valorCartao * quantidadeParcelas)}
              </h4> : <h4>-</h4>}
            </div>
          </div>
          <div
            className="PaymentMethod w-full md:w-2/4 flex justify-center items-center h-full 
                rounded-xl"
          >
            <div className=" text-slate-700 text-center overflow-auto font-semibold">
              {/* <h4>Taxa Administrativa</h4>
                        <h4 className="font-bold">{formatCurrency(feePague)}</h4> */}

              <div>
                <h4>Método de Pagamento</h4>
                <h4 className="font-branding-bold uppercase">{tipoPagamento}</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="card p-[4vh] grid w-full h-4/6 from-sky-100 to-sky-50 bg-gradient-to-br">
          <div
            className="MessageBox grid items-baseline p-[2vh] justify-center 
                rounded-xl mb-[2vh]"
          >
            <div className="paymentTypeButton text-slate-700 text-center font-semibold">
              <h5>Clique abaixo para gerar seu boleto</h5>

              {window.location.host === "6protestomanaus.paguedireto.com.br" ? (

                <div className="wppContact flex flex-col items-center justify-content-center p-3">
                  <img
                    src={whatsappPic}
                    alt="Whatsapp Logo"
                    style={{ width: "60px" }}
                  />
                  <h3>Atendimento</h3>

                  <h5>Exclusivo Via Whatsapp</h5>
                  <a href="http://wa.me/5511996383405">
                    <h5>(11) 99638-3405</h5>
                  </a>
                </div>
              ) : (
                <div>
                  {/* <h5>Selecione o método de pagamento</h5>
                  <SelectButton
                    value={tipoPagamento}
                    options={optionsPagamento}
                    onChange={(e) => setTipoPagamento(e.value)}
                  /> */}
                </div>
              )}
              {/* <div className="w-full">
                <h5>Selecione o método de pagamento</h5>
                {tipoPagamento !== "Cartão" && false &&
                <h6 className="text-red-500">*Parcele em até 12x com o cartão de crédito</h6>
                }
                <SelectButton
                  className="w-full"
                  value={tipoPagamento}
                  options={optionsPagamento}
                  onChange={(e) => {setTipoPagamento(e.value);setShowBandeiraDialog(e.value === 'Cartão' && true)}}
                  />
              </div> */}
            </div>
          </div>

          {tipoPagamento === "Cartão" && valorOriginal > 0 && (
            <div
              className="grid items-baseline p-[2vh] justify-center 
                bg-sky-300 rounded-xl "
            >
              <div className="text-slate-700 parcelasDropdown text-center font-semibold">
                <div className="flex justify-center">
                  <Tooltip 
                  position="top"
                  target=".selecionar-bandeira" />
                  <button
                  className="text-[2.2vh] text-white bg-teal-700 hover:bg-teal-900 p-[0.8vh] rounded-md 
                  flex justify-center items-center gap-[1vh] capitalize selecionar-bandeira"
                  data-pr-tooltip = 'Selecione a bandeira do seu cartão'
                  onClick={()=>setShowBandeiraDialog(true)}
                  >
                    <FaRegCreditCard  />
                    {cartaoBandeira}
                  </button>
                </div>
                <h5>Selecione o número de parcelas</h5>
                <Dropdown
                  value={dropdownValue}
                  options={parcelasOpcoes}
                  optionValue="values"
                  scrollHeight="30vh"
                  onChange={(e) => {
                    setQuantidadeParcelas(e.value.qtd_parcelas);
                    setDropdownValue(e.value);
                    setValorCartao(e.value.value);
                  }}
                  id="parcelas"
                  placeholder="Selecione aqui"
                />
              </div>
            </div>
          )}
          <div className="paymentButton flex items-end mb-20 mt-3">
            <Button
              label="Continuar"
              style={{fontFamily:'Branding-Regular, serif'}}
              disabled={
                valorOriginal === 0 ||
                tipoPagamento === null ||
                (quantidadeParcelas === undefined && tipoPagamento === "Cartão")
              }
              onClick={() => pagamento()}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
